import { render, staticRenderFns } from "./CategoryAuthorInfo.vue?vue&type=template&id=3dd55762"
import script from "./CategoryAuthorInfo.vue?vue&type=script&lang=js"
export * from "./CategoryAuthorInfo.vue?vue&type=script&lang=js"
import style0 from "./CategoryAuthorInfo.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports